export default __webpack_public_path__ + "static/media/drag.986ab654.svg";